import React from 'react';

const TermsOfService: React.FC = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-16 px-4 font-sans">
      <div className="max-w-3xl mx-auto bg-white rounded-3xl shadow-xl border border-slate-100 overflow-hidden">
        <div className="bg-brand-900 p-8 text-center">
          <h1 className="text-3xl font-black text-white tracking-tight">Terms of Service</h1>
          <p className="text-brand-200 text-sm mt-2 font-bold uppercase tracking-widest">Last Updated: May 20, 2024</p>
        </div>
        
        <div className="p-8 md:p-12 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing the FilersHub portal, you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree with any of these terms, you are prohibited from using this site.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">2. Description of Service</h2>
            <p>FilersHub provides a secure document exchange and communication platform for tax preparation firms and their clients. The portal is designed to facilitate the collection of information required for tax compliance.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">3. User Responsibilities</h2>
            <p>You are responsible for:</p>
            <ul className="list-disc ml-6 mt-2 space-y-2">
              <li>Providing accurate, complete, and up-to-date information.</li>
              <li>Maintaining the confidentiality of your login credentials.</li>
              <li>Ensuring that all documents uploaded are authentic and legally obtained.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">4. Limitation of Liability</h2>
            <p>In no event shall FilersHub or its partner firms be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on FilersHub's portal.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-slate-900 mb-3">5. Governing Law</h2>
            <p>These terms and conditions are governed by and construed in accordance with the laws of the jurisdiction in which the parent tax firm operates, and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
          </section>

          <div className="pt-8 border-t border-slate-100 text-center">
            <button 
              onClick={() => window.location.href = '/'}
              className="text-brand-600 font-bold hover:underline"
            >
              Return to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;